import { inject, Injectable } from "@angular/core";
import { ErrorHandlingService } from "@vega/error-handling";
import { ILogger, LoggerFactory } from "@vega/logging";
import { ResponseError } from "@vega/readdataaccess";
import { Observable, catchError, map } from "rxjs";
import { BusinessResultItemResponse, TransactionResponse } from "../shared/clients/transaction-client/model";
import { TransactionClient } from "../shared/clients/transaction-client/client/transaction-client";
import { ApplicationContext } from "@vega/application-context";
@Injectable()
export class TransactionService {

    private _transactionClient = inject(TransactionClient);
    private _errorHandlingService = inject(ErrorHandlingService);
    private _applicationContext = inject(ApplicationContext);
    private _logger: ILogger;

    constructor() {
        const loggerFactory = inject(LoggerFactory);

        this._logger = loggerFactory.getLogger(TransactionService.name);
    }

    public getTransactions(startDate: Date, endDate: Date, lastPayoutId: string): Observable<TransactionResponse> {
        return this._transactionClient
            .getTransactionsInformation(
                this._applicationContext.culture,
                String(this._applicationContext.mandatorId),
                startDate.toDateString(),
                endDate.toDateString(),
                100,
                lastPayoutId ?? undefined
            )
            .pipe(
                map((result: BusinessResultItemResponse<TransactionResponse>) => result.item),
                catchError((error: ResponseError) => {
                    this._errorHandlingService.handleError(error);
                    throw error;
                })
            );
    }
}
